import classNames from 'classnames'
import { useTranslation } from 'next-i18next/pages'
import parse from 'html-react-parser'
import ContactCta from 'components/contact-cta/ContactCta'
import styles from './Settlement.module.scss'
import { Heading, Header } from '@boltenergy-be/design-system'

const Settlement = () => {
  // i18n
  const { t } = useTranslation(['settlement', 'faqIncreaseInstallment'])

  return (
    <main className={styles.settlement}>
      <Header title={parse(t(($) => $.title))} docked color="accent-soft" shape="s1">
        <p>{parse(t(($) => $.description))}</p>
      </Header>

      <section className={classNames('section', styles.explanations)}>
        <div className="container">
          <div className="columns">
            <div className="column is-half">
              <div className={styles.card}>
                <Heading as="h2" variant="h3" serif>
                  {t(($) => $.moreEnergyUsage.title)}
                </Heading>
                <p>{t(($) => $.moreEnergyUsage.description)}</p>
              </div>
            </div>
            <div className="column is-half">
              <div className={styles.card}>
                <Heading as="h2" variant="h3" serif>
                  {t(($) => $.poorlyEstimated.title)}
                </Heading>
                <p>{t(($) => $.poorlyEstimated.description)}</p>
              </div>
            </div>
            <div className="column is-half">
              <div className={styles.card}>
                <Heading as="h2" variant="h3" serif>
                  {t(($) => $.incorrectIndexes.title)}
                </Heading>
                <p>{t(($) => $.incorrectIndexes.description)}</p>
              </div>
            </div>
            <div className="column is-half">
              <div className={styles.card}>
                <Heading as="h2" variant="h3" serif>
                  {t(($) => $.indexesBefore15.title)}
                </Heading>
                <p>{t(($) => $.indexesBefore15.description)}</p>
              </div>
            </div>
            <div className="column is-half">
              <div className={styles.card}>
                <Heading as="h2" variant="h3" serif>
                  {t(($) => $.winter.title)}
                </Heading>
                <p>{t(($) => $.winter.description)}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactCta
        title={t(($) => $.contact.title, { ns: 'faqIncreaseInstallment' })}
        description={t(($) => $.contact.description, { ns: 'faqIncreaseInstallment' })}
        hasDarkBg
      />
    </main>
  )
}

export default Settlement
